import { AxiosResponse } from 'axios'

export const noop = () => {}

export function isDefined<T>(value: T | undefined | null): value is T {
  return value !== undefined && value !== null
}

export const getDragDropListStyle = (isDraggingOver: boolean) => ({
  background: isDraggingOver ? '#ADD8E6' : '#EDEFF0',
})

export const downloadArrayBuffer = (response: AxiosResponse<ArrayBuffer>) => {
  const fileName = response.headers['content-disposition']
    ? response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '')
    : 'report.pdf'

  const blob = new Blob([response.data], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
